function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import ReactDOM from 'react-dom';
import { WDHComponent } from '../../../../wdh-foundation/wdh';
import { Counters, TranslationKeys, Events, SiteLinks, FeatureFlags, QueryStrings, ClientOrderMode } from './infrastructure/const';
import ApiClient from './infrastructure/api/api-client';
import ConfigurationManager from './infrastructure/configuration-manager';
import NavigationManager from './infrastructure/navigation-manager';
import TranslationManager from './infrastructure/translation-manager';
import UrlUtils from './utilities/url-utils';
import SiteLinkManager from './infrastructure/site-link-manager';
import ModalDialog from './components/modal-dialog';
import Spinner from './components/spinner';
import FeatureFlagWrapper from './components/feature-flag-wrapper';
import Logger from '../../../../wdh-foundation/wdh-logger/wdh-logger';
import CheckUtils from './utilities/check-utils';
import HttpClient from './infrastructure/http-client';
import CurrencyFormatter from './utilities/currency-formatter';
import Loader from "react-loader-advanced";
import { loaderBackgroundStyle, loaderOpacity, spinner } from "../../../../wdh-project/oticon_us/react/feature/wdh-mybusiness/src/js/views/Spinner";
import ProductsUtils from "./utilities/products-utils";
var EventBus = window.DGS.Event.getInstance();

/**
 * Component for showing the shoppign cart icon and the actual shopping cart when clicked on all pages
 * @memberOf module:wdh-feature-b2b
 */
var WDHFeatureB2BCartSpot = /*#__PURE__*/function (_WDHComponent) {
  function WDHFeatureB2BCartSpot() {
    var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'wdh-feature-b2b-cartspot';
    _classCallCheck(this, WDHFeatureB2BCartSpot);
    return _callSuper(this, WDHFeatureB2BCartSpot, [className]);
  }
  _inherits(WDHFeatureB2BCartSpot, _WDHComponent);
  return _createClass(WDHFeatureB2BCartSpot, [{
    key: "init",
    value: function init(component) {
      // Check that shop initialization has executed
      if (!ConfigurationManager.validateConfigurationLoaded(this.constructor.name)) {
        return;
      }
      ReactDOM.render(/*#__PURE__*/React.createElement(Cart, {
        className: this.className
      }), component.querySelector('.component-content'));
    }
  }]);
}(WDHComponent);
export default WDHFeatureB2BCartSpot;

/**
 * @param props
 * @memberof module:wdh-feature-b2b
 * @example
 * <Cart />
 * @private
 */
var Cart = /*#__PURE__*/function (_React$Component) {
  function Cart(props) {
    var _this;
    _classCallCheck(this, Cart);
    _this = _callSuper(this, Cart, [props]);

    /**
     * itemsCount:                    How many products are there in total in the cart
     * popupVisible:                  Flag to control visibility of the cart popup
     * showRemoveConfirmationModal:   Flag to control visibility of the remove confirmation modal
     * showRemoveConfirmationModal:   Flag to control visibility of the spinner
     * products:                      Products for the cart
     * totalPrice:                    Total price of the cart
     * @private
     * @type {Object}
     */
    _this.state = {
      itemsCount: 0,
      popupVisible: false,
      showRemoveConfirmationModal: false,
      hideSpinner: true,
      order: {
        type: '',
        continueUrl: '',
        continueText: '',
        data: {}
      },
      clickCount: 0
    };
    _this.httpClient = new HttpClient();
    _this.productId = UrlUtils.getParameterByName(QueryStrings.PRODUCT_ID);
    _this.categoryId = UrlUtils.getParameterByName(QueryStrings.CATEGORY_ID);

    /**
     * Translation texts for the component
     * @private
     * @type {Object}
     */
    _this.translations = {
      goToCheckoutButton: TranslationManager.getTranslation(TranslationKeys.SHARED_CART_GOTOCHECKOUT),
      noItemsLabel: TranslationManager.getTranslation(TranslationKeys.SHARED_CART_NOITEMS),
      removeText: TranslationManager.getTranslation(TranslationKeys.SHARED_CART_REMOVETEXT),
      removeCancel: TranslationManager.getTranslation(TranslationKeys.SHARED_CART_REMOVECANCEL),
      removeOk: TranslationManager.getTranslation(TranslationKeys.SHARED_CART_REMOVEOK),
      removeButtonTitle: TranslationManager.getTranslation(TranslationKeys.SHARED_CART_REMOVEBUTTONTITLE),
      subtotalLabel: TranslationManager.getTranslation(TranslationKeys.SHARED_PRINT_SUBTOTALLABEL),
      productsLabel: TranslationManager.getTranslation(TranslationKeys.SHARED_CART_PRODUCTS),
      leftLabel: TranslationManager.getTranslation(TranslationKeys.SHARED_LEFT),
      rightLabel: TranslationManager.getTranslation(TranslationKeys.SHARED_RIGHT),
      itemsAddedToYourCart: TranslationManager.getTranslation(TranslationKeys.SHARED_CART_CARTITEMSLABEL),
      continueShopping: TranslationManager.getTranslation(TranslationKeys.SHARED_ADDTOCARTMODAL_CONTINUESHOPPINGBUTTON),
      itemsUpdatedinYourCart: TranslationManager.getTranslation(TranslationKeys.SHARED_CART_CARTITEMSUPDATEDLABEL)
    };

    /**
     * Flag to indicate if you are on the checkout page or not
     * @private
     * @type {Bool}
     */
    _this.isCheckout = UrlUtils.isCurrentPage(SiteLinkManager.getSiteLink(SiteLinks.CHECKOUT));

    /**
     * Id of the product to remove, used in the confirmation model
     * @private
     * @type {Number}
     */
    _this.removeProductItemNumber = {};

    /**
     * Ref to the root node, to handle the click events on the componet
     * @private
     * @type {Object}
     */
    _this.rootNode = /*#__PURE__*/React.createRef();

    /**
     * Binds the event that handlse outside click, to close the cart popup
     * @private
     * @type {Func}
     */
    _this.handleOutsideClick = _this.handleOutsideClick.bind(_this);

    /**
     * Flag to control if products has been found
     * @private
     * @type {Bool}
     */
    _this.productsFound = false;
    return _this;
  }

  /**
   * Register the CART_UPDATED event in the event bus
   * Init the states
   * Register the handleOutsideClick, to be able to close the cart popup, when clicking outside it
   * @private
   */
  _inherits(Cart, _React$Component);
  return _createClass(Cart, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this2 = this;
      EventBus.on(Events.CART_UPDATED, function (order) {
        _this2.setState({
          popupVisible: true,
          order: order
        }, function () {
          document.getElementById('content').style.opacity = 0.5;
          _this2.refreshCart();
        });
      });
      EventBus.on(Events.REFRESH_CART_COUNT, function () {
        _this2.refreshCart();
      });
      document.addEventListener('click', this.handleOutsideClick, false);
      this.refreshCart();
    }

    /**
     * Unregister the handleOutsideClick, when not needed anymore
     * @private
     */
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;
      EventBus.off(Events.CART_UPDATED, function () {
        _this3.refreshCart();
      });
      document.removeEventListener('click', this.handleOutsideClick, false);
    }

    /**
     * /**
     * Show the remove confirmation modal
     * @param {Number} productId  Id of the product to remove
     * @private
     */
  }, {
    key: "onRemoveItemClicked",
    value: function onRemoveItemClicked(itemNumber, configurationId, clientOrderId, isClientOrder) {
      this.isClientOrder = isClientOrder;
      this.removeProductItemNumber = itemNumber;
      this.configurationId = configurationId;
      this.clientOrderId = clientOrderId;
      this.setState({
        showRemoveConfirmationModal: true
      });
    }

    /**
     * Close the remove confirmation modal
     * @private
     */
  }, {
    key: "onRemoveConfirmationCanceled",
    value: function onRemoveConfirmationCanceled() {
      this.setState({
        showRemoveConfirmationModal: false
      });
    }

    /**
     * Close the remove confirmation modal
     * Remove the product and refresh the cart
     * @private
     */
  }, {
    key: "onRemoveConfirmationAccepted",
    value: function onRemoveConfirmationAccepted() {
      var _this4 = this;
      var promise = null;
      if (this.isClientOrder) {
        promise = ApiClient.clientOrder.get(this.clientOrderId).then(function (clientOrder) {
          var configuration = clientOrder.configuration.find(function (config) {
            return config.id === _this4.configurationId;
          });
          if (!CheckUtils.isNullObject(configuration)) {
            configuration.isEnabled = false;
            ApiClient.clientOrder.update(clientOrder).then(function () {
              ApiClient.clientOrder.disableConfiguration(clientOrder).then(function (response) {
                if (!response.isDeleted) {
                  ApiClient.cart.addClientOrder(clientOrder.id);
                }
              }).then(function () {
                EventBus.trigger(Events.CART_UPDATED);
              });
            });
          }
        });
      } else {
        promise = ApiClient.cart.removeItem(this.removeProductItemNumber);
      }
      promise.then(function () {
        _this4.setState({
          showRemoveConfirmationModal: false
        });
        EventBus.trigger(Events.CART_UPDATED);
      }).catch(function (err) {
        _this4.setState({
          showRemoveConfirmationModal: false
        });
        Logger.error(err);
      });
    }

    /**
     * If not on the checkout page, show the cart popup
     * only load the products, if they have not already been loaded (or if they have been updated)
     * @private
     */
  }, {
    key: "onCartPopupClicked",
    value: function onCartPopupClicked() {
      window.location = '/myoticon/shop/cart-details';
    }

    /**
     * Temporary for clearing cart
     */
  }, {
    key: "onClickCount",
    value: function onClickCount() {
      var _this5 = this;
      this.setState(function (state) {
        var newState = {
          clickCount: state.clickCount + 1
        };
        return newState;
      }, function () {
        if (_this5.state.clickCount >= 10) {
          ApiClient.cart.clear().then(function () {
            _this5.setState({
              clickCount: 0
            }, function () {
              _this5.refreshCart();
            });
          });
        }
      });
    }

    /**
     * Goes to related product site based on category id and product id
     */
  }, {
    key: "goToRelatedProduct",
    value: function goToRelatedProduct() {
      var link = SiteLinkManager.getSiteLink(SiteLinks.PRODUCTLIST);
      link = '/myoticon/shop/related-Products';
      var args = _defineProperty(_defineProperty({}, QueryStrings.PRODUCT_ID, this.productId), QueryStrings.CATEGORY_ID, this.categoryId);
      return UrlUtils.createLink(link, args);
    }

    /**
     * Redirect to the checkout page
     * @private
     */
  }, {
    key: "onGoToCheckoutClicked",
    value: function onGoToCheckoutClicked(event) {
      event.preventDefault();
      NavigationManager.navigateToCheckout();
    }

    /**
     * Check if number of items in cart is larger then 99, then show 99+
     * @param {Number} itemsCount The total items in the cart
     * @private
     */
  }, {
    key: "getItemCount",
    value: function getItemCount(itemsCount) {
      if (itemsCount > Counters.maxItemsInCartLabel) {
        return "".concat(Counters.maxItemsInCartLabel, "+");
      }
      return itemsCount;
    }

    /**
     * Gets the total number of products in a bulk order
     * Total number of products = hearing aids + accessories + warranties
     * @param {Object} bulkOrder
     */
  }, {
    key: "getBulkOrderItemCount",
    value: function getBulkOrderItemCount(bulkOrder) {
      var count = 0;
      count += bulkOrder.quantity;
      if (bulkOrder.accessories) {
        count += bulkOrder.accessories.reduce(function (accumulator, accessory) {
          return accumulator + accessory.quantity;
        }, 0);
      }
      if (bulkOrder.relatedProducts) {
        count += bulkOrder.relatedProducts.reduce(function (accumulator, relatedProduct) {
          return accumulator + relatedProduct.quantity;
        }, 0);
      }
      if (bulkOrder.warranties) {
        count += bulkOrder.warranties.reduce(function (accumulator, warranty) {
          return accumulator + bulkOrder.quantity;
        }, 0);
      }
      return count;
    }
  }, {
    key: "getProductOrderItemCount",
    value: function getProductOrderItemCount(productOrder) {
      var count = 0;
      count += productOrder.quantity;
      return count;
    }
  }, {
    key: "getPatientOrderItemCount",
    value: function getPatientOrderItemCount(patientOrder) {
      var total = 0;
      if (patientOrder.relatedProductsOrders !== null && patientOrder.relatedProductsOrders !== undefined) {
        total += patientOrder.relatedProductsOrders.reduce(function (accumulator, relatedProductOrder) {
          return accumulator + relatedProductOrder.quantity;
        }, 0);
      }
      if (!CheckUtils.isNullOrEmptyArray(patientOrder.warranties)) {
        var quantity = patientOrder.type.toLowerCase() === ClientOrderMode.BINAURAL ? 2 : 1;
        total += patientOrder.warranties.reduce(function (accumulator, warranty) {
          return accumulator + quantity;
        }, 0);
      }
      return total;
    }
  }, {
    key: "getPatientOrderPrice",
    value: function getPatientOrderPrice(patientOrder) {
      var total = 0;
      if (patientOrder.relatedProductsOrders) {
        total += patientOrder.relatedProductsOrders.reduce(function (accumulator, order) {
          return accumulator + order.price * order.quantity;
        }, 0);
      }
      if (!CheckUtils.isNullOrEmptyArray(patientOrder.warranties)) {
        var quantity = patientOrder.type.toLowerCase() === ClientOrderMode.BINAURAL ? 2 : 1;
        total += patientOrder.warranties.reduce(function (accumulator, order) {
          return accumulator + order.price * quantity;
        }, 0);
      }
      return total;
    }
  }, {
    key: "getProductOrdersItemCount",
    value: function getProductOrdersItemCount(productOrders) {
      return productOrders.reduce(function (accumulator, productOrder) {
        return accumulator + productOrder.quantity;
      }, 0);
    }
  }, {
    key: "getBulkOrderPrice",
    value: function getBulkOrderPrice(bulkOrders) {
      var total = 0;
      bulkOrders.forEach(function (bulkOrder) {
        total += bulkOrder.price * bulkOrder.quantity;
        if (!CheckUtils.isNullOrEmptyArray(bulkOrder.warranties)) {
          bulkOrder.warranties.forEach(function (warranty) {
            total += warranty.price * bulkOrder.quantity;
          });
        }
        if (bulkOrder.relatedProducts != null && bulkOrder.relatedProducts !== undefined && bulkOrder.relatedProducts.length > 0) {
          for (var i = 0; i < bulkOrder.relatedProducts.length; i++) {
            total += bulkOrder.relatedProducts[i].price * bulkOrder.relatedProducts[i].quantity;
          }
        }
      });
      return total;
    }
  }, {
    key: "getProductOrderPrice",
    value: function getProductOrderPrice(productOrder) {
      var total = 0;
      total += productOrder.reduce(function (accumulator, order) {
        return accumulator + order.price * order.quantity;
      }, 0);
      return total;
    }
  }, {
    key: "setItemCountDesc",
    value: function setItemCountDesc() {
      return this.translations.productsLabel;
    }

    /**
     * Close the popup if open and user click outside it
     * @param {Object} e  Event with the target
     * @private
     */
  }, {
    key: "handleOutsideClick",
    value: function handleOutsideClick(e) {
      if (this.state.popupVisible === true && this.rootNode !== null && this.rootNode.current !== null && !this.rootNode.current.contains(e.target)) {
        this.setState({
          popupVisible: false
        }, function () {
          // TODO: Do not interact with the DOM directly
          document.getElementById('content').style.opacity = 1;
        });
      }
    }

    /**
     * Refresh the cart data (only count) for the component
     * Set the productsFound to false, to force the product to be reloaded, if cart is clicked
     * @private
     */
  }, {
    key: "refreshCart",
    value: function refreshCart() {
      var _this6 = this;
      this.productsFound = false;
      this.setState({
        hideSpinner: false
      }, function () {
        ApiClient.cart.count().then(function (count) {
          _this6.setState({
            itemsCount: count,
            hideSpinner: true
          });
        });
      });
    }
  }, {
    key: "renderBulkOrder",
    value: function renderBulkOrder(bulkOrders) {
      return /*#__PURE__*/React.createElement("ol", {
        id: "cart-sidebar",
        className: "mini-products-list"
      }, bulkOrders.map(function (bulkOrder) {
        var canSeePrices = bulkOrder.canSeePrices;
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("li", {
          className: "item",
          key: bulkOrder.id
        }, /*#__PURE__*/React.createElement("img", {
          className: "product-image",
          src: ProductsUtils.fillMissingImage(bulkOrder.imageUrl),
          onError: ProductsUtils.fillImageNotFound,
          alt: bulkOrder.name
        }), /*#__PURE__*/React.createElement("div", {
          className: "product-details"
        }, /*#__PURE__*/React.createElement("span", {
          className: "product-name"
        }, bulkOrder.name)), /*#__PURE__*/React.createElement("div", {
          className: "product-pricing"
        }, /*#__PURE__*/React.createElement("p", null, "".concat(bulkOrder.quantity, "x")), /*#__PURE__*/React.createElement("p", {
          className: "amount"
        }, canSeePrices && bulkOrder.price !== null ? CurrencyFormatter.format(bulkOrder.price) : 'N/A'))), bulkOrder.accessories && bulkOrder.accessories.map(function (accessory) {
          return /*#__PURE__*/React.createElement("li", {
            className: "item",
            key: accessory.id
          }, /*#__PURE__*/React.createElement("div", {
            className: "product-details"
          }, /*#__PURE__*/React.createElement("div", {
            className: "product-text-container"
          }, /*#__PURE__*/React.createElement("span", {
            className: "product-name"
          }, /*#__PURE__*/React.createElement("strong", {
            className: "type"
          }, accessory.type), /*#__PURE__*/React.createElement("span", null, accessory.name)))), /*#__PURE__*/React.createElement("div", {
            className: "product-pricing"
          }, /*#__PURE__*/React.createElement("p", null, "".concat(accessory.quantity, "x"))));
        }), bulkOrder.warranties !== null && bulkOrder.warranties.map(function (warranty) {
          return /*#__PURE__*/React.createElement("li", {
            className: "item",
            key: warranty.id
          }, /*#__PURE__*/React.createElement("div", {
            className: "product-details"
          }, /*#__PURE__*/React.createElement("div", {
            className: "product-text-container"
          }, /*#__PURE__*/React.createElement("span", {
            className: "product-name"
          }, warranty.description))), /*#__PURE__*/React.createElement("div", {
            className: "product-pricing"
          }, /*#__PURE__*/React.createElement("p", null, "".concat(bulkOrder.quantity, "x")), /*#__PURE__*/React.createElement("p", {
            className: "amount"
          }, canSeePrices && warranty.price !== null ? CurrencyFormatter.format(warranty.price) : 'N/A')));
        }), bulkOrder.relatedProducts.map(function (productOrder) {
          return /*#__PURE__*/React.createElement("li", {
            className: "item",
            key: productOrder.id
          }, /*#__PURE__*/React.createElement("img", {
            className: "product-image",
            src: ProductsUtils.fillMissingImage(productOrder.imageUrl),
            onError: ProductsUtils.fillImageNotFound,
            alt: productOrder.name
          }), /*#__PURE__*/React.createElement("div", {
            className: "product-details"
          }, /*#__PURE__*/React.createElement("span", {
            className: "product-name"
          }, productOrder.name)), /*#__PURE__*/React.createElement("div", {
            className: "product-pricing"
          }, /*#__PURE__*/React.createElement("p", null, "".concat(productOrder.quantity, "x")), /*#__PURE__*/React.createElement("p", {
            className: "amount"
          }, canSeePrices && productOrder.price !== null ? CurrencyFormatter.format(productOrder.price) : 'N/A')));
        }));
      }));
    }
  }, {
    key: "renderProductOrder",
    value: function renderProductOrder(productOrders) {
      return /*#__PURE__*/React.createElement("ol", {
        id: "cart-sidebar",
        className: "mini-products-list"
      }, productOrders.map(function (productOrder) {
        var canSeePrices = productOrder.canSeePrices;
        return /*#__PURE__*/React.createElement("li", {
          className: "item",
          key: productOrder.id
        }, /*#__PURE__*/React.createElement("img", {
          className: "product-image",
          src: ProductsUtils.fillMissingImage(productOrder.imageUrl),
          onError: ProductsUtils.fillImageNotFound,
          alt: productOrder.name
        }), /*#__PURE__*/React.createElement("div", {
          className: "product-details"
        }, /*#__PURE__*/React.createElement("span", {
          className: "product-name"
        }, productOrder.name)), /*#__PURE__*/React.createElement("div", {
          className: "product-pricing"
        }, /*#__PURE__*/React.createElement("p", null, "".concat(productOrder.quantity, "x")), /*#__PURE__*/React.createElement("p", {
          className: "amount"
        }, canSeePrices && productOrder.price !== null ? CurrencyFormatter.format(productOrder.price) : 'N/A')));
      }));
    }
  }, {
    key: "renderPatientOrder",
    value: function renderPatientOrder(patientOrder) {
      var canSeePrices = patientOrder.canSeePrices;
      return /*#__PURE__*/React.createElement("ol", {
        id: "cart-sidebar",
        className: "mini-products-list"
      }, patientOrder.relatedProductsOrders && patientOrder.relatedProductsOrders.map(function (relatedProductOrder) {
        return /*#__PURE__*/React.createElement("li", {
          className: "item",
          key: relatedProductOrder.id
        }, /*#__PURE__*/React.createElement("img", {
          className: "product-image",
          src: ProductsUtils.fillMissingImage(relatedProductOrder.imageUrl),
          onError: ProductsUtils.fillImageNotFound,
          alt: "Product image"
        }), /*#__PURE__*/React.createElement("div", {
          className: "product-details"
        }, /*#__PURE__*/React.createElement("div", {
          className: "product-text-container"
        }, /*#__PURE__*/React.createElement("span", {
          className: "product-name"
        }, /*#__PURE__*/React.createElement("strong", {
          className: "type"
        }, relatedProductOrder.type), /*#__PURE__*/React.createElement("span", null, relatedProductOrder.name)))), /*#__PURE__*/React.createElement("div", {
          className: "product-pricing"
        }, /*#__PURE__*/React.createElement("p", null, "".concat(relatedProductOrder.quantity, "x")), /*#__PURE__*/React.createElement("p", {
          className: "amount"
        }, canSeePrices && relatedProductOrder.price !== null ? CurrencyFormatter.format(relatedProductOrder.price * relatedProductOrder.quantity) : 'N/A')));
      }), patientOrder.warranties && patientOrder.warranties.map(function (warranty) {
        return /*#__PURE__*/React.createElement("li", {
          className: "item",
          key: warranty.id
        }, /*#__PURE__*/React.createElement("div", {
          className: "product-details"
        }, /*#__PURE__*/React.createElement("div", {
          className: "product-text-container"
        }, /*#__PURE__*/React.createElement("span", {
          className: "product-name"
        }, warranty.description))), /*#__PURE__*/React.createElement("div", {
          className: "product-pricing"
        }, /*#__PURE__*/React.createElement("p", null, "".concat(patientOrder.type.toLowerCase() === ClientOrderMode.BINAURAL ? 2 : 1, "x")), /*#__PURE__*/React.createElement("p", {
          className: "amount"
        }, canSeePrices && warranty.price !== null ? CurrencyFormatter.format(warranty.price) : 'N/A')));
      }));
    }
  }, {
    key: "renderPopup",
    value: function renderPopup() {
      if (!this.state.popupVisible) {
        return null;
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "headercart-box"
      }, /*#__PURE__*/React.createElement("div", {
        id: "recently-added-container",
        className: "popdown"
      }, this.renderPopupMessage(), this.renderPopupItems(), this.renderPopupButtons()));
    }
  }, {
    key: "renderPopupMessage",
    value: function renderPopupMessage() {
      var _this7 = this;
      if (this.state.itemsCount === 0) {
        return /*#__PURE__*/React.createElement("div", {
          className: "showing-items"
        }, /*#__PURE__*/React.createElement("strong", null, this.translations.noItemsLabel));
      }
      var cartStatusText = '';
      var count = 0;
      var addUpdateText = this.state.order.isEditOrder ? this.translations.itemsUpdatedinYourCart : this.translations.itemsAddedToYourCart;
      switch (this.state.order.type) {
        case 'bulkOrder':
          count = this.getBulkOrderItemCount(this.state.order.data);
          cartStatusText = "".concat(count > 0 ? count : '', " ").concat(addUpdateText);
          break;
        case 'productOrder':
          count = this.getProductOrdersItemCount(this.state.order.data);
          cartStatusText = "".concat(count > 0 ? count : '', " ").concat(addUpdateText);
          break;
        case 'patientOrder':
          count = this.getPatientOrderItemCount(this.state.order.data);
          cartStatusText = "".concat(count > 0 ? count : '', " ").concat(addUpdateText);
          break;
        default:
          cartStatusText = addUpdateText;
          break;
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "showing-items"
      }, /*#__PURE__*/React.createElement("span", {
        className: "items",
        onClick: function onClick() {
          return _this7.onClickCount();
        },
        role: "presentation"
      }, /*#__PURE__*/React.createElement("strong", null, cartStatusText)), /*#__PURE__*/React.createElement(FeatureFlagWrapper, {
        featureFlag: FeatureFlags.CAN_SEE_PRICES
      }, /*#__PURE__*/React.createElement("span", {
        className: "total"
      }, /*#__PURE__*/React.createElement("strong", null, this.translations.subtotalLabel, ": "), this.state.order.data.canSeePrices ? this.state.order.type === "bulkOrder" && CurrencyFormatter.format(this.getBulkOrderPrice(this.state.order.data)) || this.state.order.type === "productOrder" && CurrencyFormatter.format(this.getProductOrderPrice(this.state.order.data)) || this.state.order.type === "patientOrder" && CurrencyFormatter.format(this.getPatientOrderPrice(this.state.order.data)) : 'N/A')));
    }
  }, {
    key: "renderPopupItems",
    value: function renderPopupItems() {
      if (this.productsFound || CheckUtils.isNullOrEmptyArray(this.state.order.data)) {
        return null;
      }
      var subtotal = null;
      var canSeePrices = true;
      switch (this.state.order.type) {
        case 'bulkOrder':
          subtotal = this.getBulkOrderPrice(this.state.order.data);
          canSeePrices = this.state.order.data[0].canSeePrices;
          break;
        case 'productOrder':
          subtotal = this.getProductOrderPrice(this.state.order.data);
          canSeePrices = this.state.order.data[0].canSeePrices;
          break;
        case 'patientOrder':
          subtotal = this.getPatientOrderPrice(this.state.order.data);
          canSeePrices = this.state.order.data.canSeePrices;
          break;
        default:
          subtotal = null;
          break;
      }
      subtotal = canSeePrices && subtotal !== null ? CurrencyFormatter.format(subtotal) : 'N/A';
      return /*#__PURE__*/React.createElement(React.Fragment, null, Object.entries(this.state.order.data).length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, this.state.order.type === 'bulkOrder' && this.renderBulkOrder(this.state.order.data), this.state.order.type === 'productOrder' && this.renderProductOrder(this.state.order.data), this.state.order.type === 'patientOrder' && this.renderPatientOrder(this.state.order.data), /*#__PURE__*/React.createElement("div", {
        className: "sub-total"
      }, /*#__PURE__*/React.createElement("p", null, "Subtotal"), /*#__PURE__*/React.createElement("p", {
        className: "amount"
      }, subtotal))));
    }
  }, {
    key: "renderPopupButtons",
    value: function renderPopupButtons() {
      var _this8 = this;
      if (this.state.itemsCount === 0) {
        return null;
      }
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
        id: "continue-shopping-button",
        className: "wdh-feature-b2b-button inverted-button",
        onClick: function onClick(evt) {
          evt.preventDefault();
          _this8.setState({
            popupVisible: false
          }, function () {
            document.getElementById('content').style.opacity = 1;
          });
        }
      }, this.translations.continueShopping), /*#__PURE__*/React.createElement("a", {
        id: "review-your-cart-button",
        className: "wdh-feature-b2b-button dark-bg",
        href: this.state.order.continueUrl
      }, "".concat(this.state.order.continueText, " (").concat(this.state.itemsCount, ")")));
    }
  }, {
    key: "renderCart",
    value: function renderCart() {
      var _this9 = this;
      return /*#__PURE__*/React.createElement("div", {
        className: "cart-box",
        onClick: function onClick() {
          return _this9.onCartPopupClicked();
        },
        role: "presentation",
        disabled: this.isCheckout
      }, /*#__PURE__*/React.createElement("div", {
        className: "cart-items"
      }, /*#__PURE__*/React.createElement("span", {
        className: "cart-qty"
      }, this.getItemCount(this.state.itemsCount)), /*#__PURE__*/React.createElement("span", {
        className: "cart-desc"
      }, this.setItemCountDesc())));
    }
  }, {
    key: "render",
    value: function render() {
      var _this0 = this;
      return /*#__PURE__*/React.createElement("div", {
        ref: this.rootNode
      }, this.renderCart(), /*#__PURE__*/React.createElement(Loader, {
        show: !this.state.hideSpinner,
        message: spinner,
        contentBlur: loaderOpacity,
        backgroundStyle: loaderBackgroundStyle
      }, this.renderPopup(), /*#__PURE__*/React.createElement(ModalDialog, {
        isOpen: this.state.showRemoveConfirmationModal,
        type: ModalDialog.types.okCancel,
        onOkClick: function onOkClick() {
          return _this0.onRemoveConfirmationAccepted();
        },
        okLabel: this.translations.removeOk,
        onCancelClick: function onCancelClick() {
          return _this0.onRemoveConfirmationCanceled();
        },
        cancelLabel: this.translations.removeCancel,
        blurElementID: "wrapper"
      }, /*#__PURE__*/React.createElement("p", null, this.translations.removeText))));
    }
  }]);
}(React.Component);
Cart.propTypes = {};
Cart.defaultProps = {};